export const pickProperty = (propertyName: string) => (item: {}) => item[propertyName];
